import { Note } from './BriefSectionTypes'

export const formatThousands = (value: number): string => Math.trunc(value).toLocaleString('en-US')

export const findNote = <T extends { id: string; notes?: Note[] }>(
  sections: T[],
  sectionId: string,
  noteId: string
): Note | undefined => sections.find(section => section.id === sectionId)?.notes?.find(note => note.id === noteId)
